export const DigitalProductActionTypes = {
    API_RESPONSE_SUCCESS: '@@asset/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@asset/API_RESPONSE_ERROR',

    LIST_DIGITAL_PRODUCT: '@@asset/LIST_DIGITAL_PRODUCT',
    SHOW_DIGITAL_PRODUCT: '@@asset/SHOW_DIGITAL_PRODUCT',
    FILTER_DIGITAL_PRODUCT: '@@asset/FILTER_DIGITAL_PRODUCT',
};